<script setup lang="ts">
import { ref } from 'vue';
import {
  RouterView,
  useRouter,
} from 'vue-router';

import VLoader from '@components/loader/VLoader.vue';
import VConfirmDeletePopup from '@components/popups/VConfirmDeletePopup/VConfirmDeletePopup.vue';
import createLoginLogoutHandler from '@modules/core/utils/createLoginLogoutHandler';
import waitAppReady from '@modules/core/utils/waitAppReady';
import { useNewAppVersionStore } from '@modules/new-app-version/store';
import TheToast from '@modules/toast/components/TheToast/TheToast.vue';
import { RETRY_QUERY_TOAST_GROUP } from '@modules/toast/constants';
import { useUserStore } from '@modules/user/store';

const isAppReady = ref(false);

void waitAppReady().then(() => {
  isAppReady.value = true;
});
useUserStore();
useNewAppVersionStore();

void createLoginLogoutHandler(useRouter());
</script>

<template>
  <!-- Render hidden Tag component to define its styles so we can use CSS classes and variables across the project -->
  <PTag class="hidden" />
  <TheToast />
  <TheToast
    position="bottom-left"
    :group="RETRY_QUERY_TOAST_GROUP"
  />
  <PConfirmDialog
    group="confirmDialog"
    class="max-w-[calc(100vw-40px)] md:min-w-[450px]"
    :draggable="false"
  />
  <VConfirmDeletePopup />
  <VLoader
    :loading="!isAppReady"
    spinner-wrapper-class="w-full h-full"
    spinner-size="large"
    stroke-width="3px"
  >
    <div class="h-full">
      <RouterView />
    </div>
  </VLoader>
</template>

<style lang="scss">
@import '@/assets/sass/main';
</style>
